import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { Product } from '../../../../interfaces/product';
import { ProductsService } from '../../../../services/products.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastsManager } from 'ng2-toastr';
import { LoggerService } from 'app/services/logger.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-product-select-dialog',
  templateUrl: './product-select-dialog.component.html',
  styleUrls: ['./product-select-dialog.component.scss']
})
export class ProductSelectDialogComponent implements OnInit {
  public displayedColumns: Array<string> = ['name', 'category', 'price'];
  public availableProducts: Product[];
  public dataSource: MatTableDataSource<Product>;
  public productAddForm: FormGroup;
  public selectedProduct: Product;

  constructor(
    public dialogRef: MatDialogRef<ProductSelectDialogComponent>,
    private productService: ProductsService,
    private toastr: ToastsManager,
    public translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.productAddForm = new FormGroup({
      priceDuringLoyalty: new FormControl('', [Validators.required]),
      priceAfterLoyalty: new FormControl('', [Validators.required]),
      discountedBillingPeriodsCount: new FormControl('', [Validators.required]),
      discountedBillingPeriodPrice: new FormControl('', [Validators.required]),
      priceDiscountDuringLoyalty: new FormControl('', [Validators.required]),
      isOptional: new FormControl(false, [Validators.required]),
      isGift: new FormControl(false, [Validators.required]),
      isTryAndBuy: new FormControl(false, [Validators.required])
    });
  }

  ngOnInit() {
    this.productService.getProducts({}).subscribe(
      products => {
        this.dataSource = new MatTableDataSource<Product>(products);
        this.availableProducts = products;
      },
      error => {
        LoggerService.log('ProductSelectDialog::ngOnInit', error);
        this.toastr.error(this.translate.instant('PRODUCT_SELECT.ERROR'));
      }
    );
  }

  onTryAndBuy(value: any): void {
    if (value.checked) {
      this.productAddForm.controls['discountedBillingPeriodPrice'].setValue(0);
      this.productAddForm.controls['discountedBillingPeriodPrice'].disable();
    } else {
      this.productAddForm.controls['discountedBillingPeriodPrice'].enable();
    }
  }

  selectProduct(product: Product) {
    this.selectedProduct = product;
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }

  save() {
    const offerFeature = {
      priceDuringLoyalty: this.productAddForm.value.priceDuringLoyalty,
      priceAfterLoyalty: this.productAddForm.value.priceAfterLoyalty,
      discountedBillingPeriodsCount: this.productAddForm.value.discountedBillingPeriodsCount,
      discountedBillingPeriodPrice: this.productAddForm.value.discountedBillingPeriodPrice,
      priceDiscountDuringLoyalty: this.productAddForm.value.priceDiscountDuringLoyalty,
      product: this.selectedProduct,
      isOptional: this.productAddForm.value.isOptional,
      isGift: this.productAddForm.value.isGift,
      isTryAndBuy: this.productAddForm.value.isTryAndBuy
    };
    this.dialogRef.close(offerFeature);
  }

  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/offers/offer-edit/product-select-dialog/product-select-dialog.component.ts